import LogOut from './LogOut';
export default LogOut;